export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500
}

export const EMPTY_FIELD_MESSAGE = 'This field cannot be empty'
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email'
